<h2 class="certificates-step__title">Elenco certificati</h2>
<div class="certificates-step__divider"></div>

@if (getBatch | async) {
  <input
    #certificateFileInput
    type="file"
    accept=".pdf"
    hidden
    (change)="onCertificateSelected($event)"
  />
  <div class="certificates-step__list">
    @for (
      certificate of getBatch | async;
      track certificate.supplier_certificate_document_id
    ) {
      <div class="certificates-step__row">
        <div class="certificates-step__cell certificates-step__cell--name">
          {{ certificate.document_description }}
        </div>

        <div class="certificates-step__cell certificates-step__cell--file">
          <span class="certificates-step__icon certificates-step__icon--pdf">
            <!-- <i class="bx bxs-file-pdf"></i> -->
            @if (certificate.document_url) {
              <a href="{{ certificate?.document_url }}" target="_blank">
                <i class="bx bxs-file-pdf"></i>
              </a>
            }
          </span>

          <button
            type="button"
            class="certificates-step__icon certificates-step__icon--delete"
            (click)="
              removeCertificate(
                certificate.supplier_certificate_document_id,
                $event
              )
            "
          >
            <i class="bx bx-trash"></i>
          </button>
        </div>
      </div>
    }
  </div>
} @else {
  <p class="certificates-step__empty">Nessun certificato disponibile.</p>
}
